export enum PurchaseOrderPaymentStatusEnum {
  Unpaid = 'Unpaid',
  PartiallyPaid = 'Partially Paid',
  Paid = 'Fully Paid',
  OverPaid = 'Over Paid',
}
